<template>
  <div class="header-navigation">
    <header-overview-link v-if="$mq !== 'mobile'"
                          class="overview-link" />
    <header-children />
  </div>
</template>

<script>
  import HeaderOverviewLink from './HeaderOverviewLink'
  import HeaderChildren from './HeaderChildren'

  export default {
    components: {
      HeaderOverviewLink,
      HeaderChildren
    }
  }
</script>

<style lang="scss" scoped>
  .header-navigation {
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;

    .overview-link {
      flex-shrink: 0;
      
      &:not(:last-child) {
        margin-right: 28px;
      }
    }
  }
</style>
